export const Attendance = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
      <path
        d="M6.64681 22.9737V18.4481C6.64681 17.6295 6.97118 16.8572 7.54268 16.2857C8.12962 15.6987 8.88647 15.3898 9.7051 15.3898C11.3887 15.3898 12.7634 16.7645 12.7634 18.4635V26.0629C12.7634 26.6653 13.2422 27.1442 13.8446 27.1442C14.447 27.1442 14.9258 26.6653 14.9258 26.0629V18.4635C14.9258 17.5522 14.6633 16.7027 14.2617 15.9613C14.308 15.9458 14.3543 15.9304 14.4007 15.8995C15.3583 15.2353 16.7485 15.2044 17.7988 15.8995C18.6638 16.471 19.1735 17.4287 19.1735 18.4481V26.0475C19.1735 26.6499 19.6523 27.1287 20.2547 27.1287C20.8571 27.1287 21.3359 26.6499 21.3359 26.0475V18.4481C21.3359 17.5522 21.1042 16.7027 20.6872 15.9458C20.7181 15.9304 20.7644 15.9304 20.7953 15.8995C21.2896 15.5597 21.8765 15.3743 22.4789 15.3743C24.1625 15.3743 25.5526 16.749 25.5526 18.4481V22.9737C25.5526 23.5761 26.0315 24.055 26.6339 24.055C27.2362 24.055 27.7151 23.5761 27.7151 22.9737V18.4481C27.7151 15.5597 25.3673 13.2119 22.4789 13.2119C21.444 13.2119 20.44 13.5208 19.5751 14.1078C19.4669 14.185 19.3897 14.2777 19.3125 14.3704C19.2044 14.2777 19.1117 14.185 19.0036 14.0923C17.2427 12.9184 14.8486 12.9493 13.1804 14.0923C13.0723 14.1696 12.9951 14.2622 12.9333 14.3549C12.0374 13.6444 10.9253 13.2119 9.7051 13.2119C8.31497 13.2119 7.00207 13.7525 6.01353 14.7411C5.02499 15.7296 4.48438 17.0425 4.48438 18.4326V22.9583C4.48438 23.5607 4.9632 24.0395 5.56559 24.0395C6.16798 24.0395 6.64681 23.5607 6.64681 22.9583V22.9737Z"
        fill="#424242"
      />
      <path
        d="M9.70519 12.0686C11.0953 12.0686 12.2229 10.941 12.2229 9.55089C12.2229 8.16076 11.0953 7.0332 9.70519 7.0332C8.31506 7.0332 7.1875 8.16076 7.1875 9.55089C7.1875 10.941 8.31506 12.0686 9.70519 12.0686ZM9.70519 8.56235C10.2458 8.56235 10.6783 8.99484 10.6783 9.53544C10.6783 10.0761 10.2458 10.5085 9.70519 10.5085C9.16458 10.5085 8.73209 10.0761 8.73209 9.53544C8.73209 8.99484 9.16458 8.56235 9.70519 8.56235Z"
        fill="url(#paint0_linear_8363_192756)"
      />
      <path
        d="M16.1114 12.0686C17.5016 12.0686 18.6291 10.941 18.6291 9.55089C18.6291 8.16076 17.5016 7.0332 16.1114 7.0332C14.7213 7.0332 13.5938 8.16076 13.5938 9.55089C13.5938 10.941 14.7213 12.0686 16.1114 12.0686ZM16.1114 8.56235C16.652 8.56235 17.0845 8.99484 17.0845 9.53544C17.0845 10.0761 16.652 10.5085 16.1114 10.5085C15.5708 10.5085 15.1383 10.0761 15.1383 9.53544C15.1383 8.99484 15.5708 8.56235 16.1114 8.56235Z"
        fill="url(#paint1_linear_8363_192756)"
      />
      <path
        d="M22.6349 12.0686C24.025 12.0686 25.1526 10.941 25.1526 9.55089C25.1526 8.16076 24.025 7.0332 22.6349 7.0332C21.2447 7.0332 20.1172 8.16076 20.1172 9.55089C20.1172 10.941 21.2447 12.0686 22.6349 12.0686ZM22.6349 8.56235C23.1755 8.56235 23.608 8.99484 23.608 9.53544C23.608 10.0761 23.1755 10.5085 22.6349 10.5085C22.0943 10.5085 21.6618 10.0761 21.6618 9.53544C21.6618 8.99484 22.0943 8.56235 22.6349 8.56235Z"
        fill="url(#paint2_linear_8363_192756)"
      />
      <path
        d="M10.8488 31.5H21.1512C26.8508 31.5 31.5 26.8508 31.5 21.1512V10.8488C31.5 5.14923 26.8508 0.5 21.1512 0.5H10.8488C5.14923 0.5 0.5 5.14923 0.5 10.8488V21.1512C0.5 26.8508 5.14923 31.5 10.8488 31.5ZM2.66243 10.8488C2.66243 6.33857 6.33857 2.66243 10.8488 2.66243H21.1512C25.6614 2.66243 29.3376 6.33857 29.3376 10.8488V21.1512C29.3376 25.6614 25.6614 29.3376 21.1512 29.3376H10.8488C6.33857 29.3376 2.66243 25.6614 2.66243 21.1512V10.8488Z"
        fill="#424242"
      />
      <defs>
        <linearGradient
          id="paint0_linear_8363_192756"
          x1="7.1875"
          y1="9.53544"
          x2="12.2383"
          y2="9.53544"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F4C074" />
          <stop offset="0.34" stopColor="#E3B16A" />
          <stop offset="1" stopColor="#BE7B2B" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_8363_192756"
          x1="13.5783"
          y1="9.53544"
          x2="18.6291"
          y2="9.53544"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F4C074" />
          <stop offset="0.34" stopColor="#E3B16A" />
          <stop offset="1" stopColor="#BE7B2B" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_8363_192756"
          x1="20.1172"
          y1="9.53544"
          x2="25.168"
          y2="9.53544"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F4C074" />
          <stop offset="0.34" stopColor="#E3B16A" />
          <stop offset="1" stopColor="#BE7B2B" />
        </linearGradient>
      </defs>
    </svg>
  );
};
